function TermsAndConditions() {
    document.title = 'Varosa - Terms and Conditions';
    return (
        <>
            <div className="container-fluid feature py-5">
                <div className="container py-5">
                    <div className="row g-4 justify-content-center">
                        <div className="col-12wow fadeInUp" data-wow-delay="0.1s">
                            <div className="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s">
                                <h1 className="display-3 mb-4">Terms and Conditions</h1>
                            </div>
                            <p>
                                Effective Date: [01.11.2025]<br />
                                Last Updated: [20.11.2025]<br />
                                <br />
                                Welcome to Varosa Health Technologies Private Limited (“Company”, “We”, “Us”, “Our”). These Terms & Conditions (“Terms”) govern your access and use of our telemedicine website, mobile application, and related digital healthcare services (“Services”).<br />
                                <br />
                                By accessing or using our Services, you agree to comply with and be bound by these Terms. If you do not agree, please discontinue using our Services.<br />
                                <br />
                                1. Eligibility<br />
                                You must be 18 years or older to use our Services.<br />
                                Minors may use the Services only under the supervision and consent of a parent or legal guardian.<br />
                                <br />
                                2. Nature of Services<br />
                                We provide:<br />
                                Online medical consultations<br />
                                Digital prescription issuance<br />
                                Access to health records and medical information<br />
                                Telemedicine support and guidance<br />
                                These services are not a replacement for emergency or in-person medical care. In case of life-threatening situations, please contact local emergency services immediately.<br />
                                <br />
                                3. User Responsibilities<br />
                                By using our Services, you agree to:<br />
                                Provide accurate and complete information<br />
                                Maintain confidentiality of your login credentials<br />
                                Use the Services only for lawful healthcare purposes<br />
                                Follow medical advice responsibly<br />
                                You are solely responsible for all activities under your account.<br />
                                <br />
                                4. Doctor–Patient Relationship<br />
                                A valid doctor-patient relationship is established only:<br />
                                When you complete the consultation booking process, and<br />
                                A registered medical practitioner accepts your case<br />
                                The consulting doctor has sole discretion to accept, reject, or discontinue a consultation based on medical judgment.<br />
                                <br />
                                5. Payment & Cancellation<br />
                                Charges for consultations and other services will be displayed prior to confirmation.<br />
                                Payments must be completed using authorized gateways.<br />
                                Refunds or cancellations are subject to our Refund Policy (if applicable).<br />
                                We reserve the right to modify pricing at any time.<br />
                                <br />
                                6. Electronic Prescriptions<br />
                                Prescriptions issued digitally are valid as per applicable Indian laws and must be used responsibly.<br />
                                They may not be issued for certain controlled or prohibited substances.<br />
                                <br />
                                7. Intellectual Property<br />
                                All content, trademarks, logos, software, interfaces, and designs on our platform are owned by or licensed to the Company.<br />
                                Users may not copy, modify, distribute, or create derivative works without written consent.<br />
                                <br />
                                8. Prohibited Conduct<br />
                                You agree not to:<br />
                                Misuse or interfere with platform operations<br />
                                Impersonate another person<br />
                                Record or distribute consultation content without permission<br />
                                Upload harmful, abusive, defamatory, or unlawful material<br />
                                Breach data security or attempt system intrusion<br />
                                Violations may result in account suspension or termination.<br />
                                <br />
                                9. Data Privacy<br />
                                Your use of the Services is governed by our Privacy Policy.<br />
                                By using the platform, you consent to the collection and processing of personal and health information as described there.<br />
                                <br />
                                10. Limitation of Liability<br />
                                We strive to provide reliable and secure digital healthcare; however:<br />
                                We do not guarantee uninterrupted or error-free service<br />
                                All consultations and advice are based on information you provide<br />
                                The Company is not liable for:<br />
                                Inaccurate, incomplete, or misleading health information shared by users<br />
                                Delays, technical disruptions, or data breaches beyond reasonable control<br />
                                Adverse outcomes resulting from consultation or prescription misuse<br />
                                To the maximum extent permitted by law, our liability is limited to the amount paid for the specific service.<br />
                                <br />
                                11. Indemnification<br />
                                You agree to indemnify and hold the Company, its employees, and doctors harmless from any claims or damages arising out of your misuse of the Services or breach of these Terms.<br />
                                <br />
                                12. Third-Party Services<br />
                                We may integrate with third-party platforms for payments, analytics, or medical processes.<br />
                                We are not responsible for their content, practices, or service performance.<br />
                                <br />
                                13. Modification of Terms<br />
                                We may update or modify these Terms occasionally.<br />
                                Continued use of the Services constitutes acceptance of the revised terms.<br />
                                <br />
                                14. Governing Law & Jurisdiction<br />
                                These Terms are governed by the laws of India.<br />
                                Any disputes will be subject to the exclusive jurisdiction of courts located in [Insert Jurisdiction – typically city of registered office].<br />
                                <br />
                                15. Contact Information<br />
                                For any queries, support, or legal notices, please contact:<br />
                                <br />
                                Varosa Health Technologies Private Limited<br />
                                Email: varosahealth@gmail.com<br />
                                Support & Helpline: +91 8240112175<br />
                                Office Number (10am-6pm): +91 3482329183 <br />
                                Address: 63, A.C. ROAD, (LANE-10), P.O. KHAGRA, BERHAMPORE, KHAGRA, MURSHIDABAD, BERHAMPORE - 742103, WEST BENGAL<br />
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default TermsAndConditions;